<template>
    <div>
        <div class="container-fluid featured-image-services">
            <div class="feature-header-page">
                    <h1>Why Choose Us</h1>
                </div>
        </div>
        <div class="container">
            <div class="row">
                <div class="col-sm-12 client-header">
                    <h2>Why Choose Us</h2>
                    <hr>
                    <p>Harling Taxis Ltd is a family business that has been established successfully since 2008.</p>
                    <p>Being a family business, all our drivers have been able to put that extra care into making sure that every customer feels comfortable on their journey with a familiar driver. </p>
                    <p>All our drivers are fully licensed through Breckland council with great local knowledge and the most advanced up to date background checks meaning yourself and those closest to you are able to travel to the destination in the safest of environments.</p>
                    <p>All our drivers and vehicles are also fully insured with up to £10 million liability.
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'client-switch'
}
</script>



// WEBPACK FOOTER //
// src/components/pages/WhyUseUs.vue